import { useEffect } from 'react';
import { usePlatform } from '@/hooks/usePlatform';
import { useFullscreen } from '@/hooks/useFullscreen';

export const AndroidOptimizer = () => {
  const { isAndroid } = usePlatform();
  const { isFullscreen } = useFullscreen(isAndroid);

  useEffect(() => {
    if (!isAndroid) return;

    console.log('🤖 Optimizaciones Android activas');

    // Prevenir zoom con gestos (pinch)
    const preventZoom = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    // Prevenir navegación con gestos del sistema (swipe desde bordes)
    const preventGestures = (e: TouchEvent) => {
      const touch = e.touches[0];
      if (touch.clientX < 10 || touch.clientX > window.innerWidth - 10) {
        e.preventDefault();
      }
    };

    // Prevenir context menu (long press)
    const preventContextMenu = (e: Event) => e.preventDefault();

    document.addEventListener('touchstart', preventZoom, { passive: false });
    document.addEventListener('touchstart', preventGestures, { passive: false });
    document.addEventListener('contextmenu', preventContextMenu);

    return () => {
      document.removeEventListener('touchstart', preventZoom);
      document.removeEventListener('touchstart', preventGestures);
      document.removeEventListener('contextmenu', preventContextMenu);
    };
  }, [isAndroid]);

  useEffect(() => {
    if (isAndroid && isFullscreen) {
      console.log('✅ Modo Kiosk fullscreen activo');
    }
  }, [isAndroid, isFullscreen]);

  return null; // Componente invisible de optimización
};
